import { DEFAULT_DOT_OPACITY } from "constants/chart.constants";
import { EvaChartStates } from "types/factory";

import { DEFAULT_Z_INDEX, HIGHLIGHTED_Z_INDEX } from "../../translators/constants";
import { computeMaterialBalanceSelectionStates } from "../../translators/utils";

export function materialBalanceHighlightedSeries(states: Partial<EvaChartStates>) {
  const {
    series,
    layout,
    hoverLegendItem,
    selectedGroups = [],
    attentionWells = []
  } = states;

  const isOpaque = !(hoverLegendItem || selectedGroups.length > 0);

  const labels = {};
  for (const kvp of layout.yAxis.labels) {
    labels[kvp.value] = kvp.label;
  }

  return series.map((s, index) => {
    const { label, groupTitle } = s;

    const { isHovered } = computeMaterialBalanceSelectionStates({
      hoverLegendItem,
      label,
      selectedGroups,
      groupTitle,
      attentionWells
    });

    return {
      id: `${label}, ${index}`,
      itemStyle: {
        opacity: isOpaque ? DEFAULT_DOT_OPACITY : isHovered ? DEFAULT_DOT_OPACITY : 0.2
      },
      z: isHovered ? HIGHLIGHTED_Z_INDEX : DEFAULT_Z_INDEX
    };
  });
}
